import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import UsersTable from "@/components/admin/users-table/UsersTable";
import { StrategyProvider, UserRole } from "@/types/strategy-types";
import { AdminUser, SortField } from "@/hooks/admin/users/types";

interface UsersTabProps {
  users: AdminUser[];
  strategies: any[];
  providers: StrategyProvider[];
  updateUserRole: (roleId: string, newRole: UserRole) => Promise<void>;
  updateUserName: (userId: string, firstName: string, lastName: string) => Promise<void>;
  deleteUser: (userId: string) => Promise<void>;
  sortField?: SortField;
  sortOrder?: 'asc' | 'desc';
  handleSort?: (field: SortField) => void;
}

const UsersTab = ({ 
  users, 
  strategies, 
  providers, 
  updateUserRole,
  updateUserName,
  deleteUser,
  sortField,
  sortOrder,
  handleSort
}: UsersTabProps) => {
  return (
    <TabsContent value="users">
      <UsersTable 
        users={users} 
        strategies={strategies}
        providers={providers}
        onUpdateRole={updateUserRole}
        onUpdateUserName={updateUserName}
        onDeleteUser={deleteUser}
        sortField={sortField}
        sortOrder={sortOrder}
        onSort={handleSort}
      />
    </TabsContent>
  );
};

export default UsersTab;
